import React from "react";
import { Col, Container, Row } from "reactstrap";

const Movimentação = ({meses, anos}) =>{

  // const dados = [{
  //   mes:'04/24',
  //   entradas:'5',
  //   saidas:'4'
  // },{
  //   mes:'05/24',
  //   entradas:'5',
  //   saidas:'4'
  // },{
  //   mes:'06/24',
  //   entradas:'5',
  //   saidas:'4'
  // },{
  //   mes:'04/24',
  //   entradas:'5',
  //   saidas:'4'
  // },{
  //   mes:'05/24',
  //   entradas:'5',
  //   saidas:'4'
  // },{
  //   mes:'06/24',
  //   entradas:'5',
  //   saidas:'4'
  // },{
  //   mes:'04/24',
  //   entradas:'5',
  //   saidas:'4'
  // },{
  //   mes:'05/24',
  //   entradas:'5',
  //   saidas:'4'
  // },{
  //   mes:'06/24',
  //   entradas:'5',
  //   saidas:'4'
  // },{
  //   mes:'04/24',
  //   entradas:'5',
  //   saidas:'4'
  // },{
  //   mes:'05/24',
  //   entradas:'5',
  //   saidas:'4'
  // },{
  //   mes:'06/24',
  //   entradas:'5',
  //   saidas:'4'
  // },]

  let totalEntrada = 0;
  let totalSaida = 0;

  return(
    <>
    <div>      
      <h6 className="font-weight-bold text-center border-top border-left border-right mb-0 py-2" style={{textWrapMode:'nowrap'}} >Últimos 12 meses</h6>

      <div className="d-flex border-top border-left border-right">
        <div className="d-flex justify-content-center header-column-cell w-100"><p className="mb-0 font-weight-bold text-center">Mês</p></div>
        <div className="d-flex justify-content-center header-column-cell w-100"><p className="mb-0 font-weight-bold text-center">Entradas</p></div>
        <div className="d-flex justify-content-center header-column-cell w-100"><p className="mb-0 font-weight-bold text-center">Saídas</p></div>
      </div>

      {meses.map((linha,idx)=>
         <div className={"d-flex border-top border-left border-right" + ((idx % 2 != 0) ? ' row-color ' : '')}>
          <div className="d-flex justify-content-center column-cell py-0 w-100"><p className="mb-0 text-center">{`${linha.num_mes.toString().padStart(2,'0')}/${linha.ano}`}</p></div>
          <div className="d-flex justify-content-center column-cell py-0 w-100"><p className="mb-0 text-center">{linha.entrada}</p></div>
          <div className="d-flex justify-content-center column-cell py-0 w-100"><p className="mb-0 text-center">{linha.saida}</p></div>
       </div>       
      )}

      <div className="border d-flex">
        <div className="d-flex justify-content-center header-column-cell w-100"><p className="mb-0 font-weight-bold">Total</p></div>
        {meses.map(linha=>{
          totalEntrada  += parseInt(linha.entrada); 
          totalSaida    += parseInt(linha.saida); 
        })}
        <div className="d-flex justify-content-center header-column-cell w-100"><p className="mb-0 font-weight-bold">{totalEntrada}</p></div>
        <div className="d-flex justify-content-center header-column-cell w-100"><p className="mb-0 font-weight-bold">{totalSaida}</p></div>
      </div> 
      
    </div>
    <div className="mt-4 border-left border-right border-top">
      <h6 className="font-weight-bold text-center mb-0 py-2" style={{textWrapMode:'nowrap'}} >Últimos Anos</h6>
    
      <div className="border-top d-flex">
        <div className="column-cell"><i className="fas fa-circle mx-1 cor-movimento-mes"></i>Período da análise</div>
        <div className="column-cell"><i className="fas fa-circle mx-1 cor-movimento-mes-seguinte"></i>Mês seguinte</div>
      </div>
   
      <div className="d-flex border-top border-left border-right">
        {anos.map(ano=>
          
            <div className="d-flex w-100"><p className="header-column-cell cor-movimento-mes mr-0">{ano.atual}</p><p className="header-column-cell cor-movimento-mes-seguinte ml-0">{ano.anterior}</p></div>
            // <div className="d-flex w-100"><p className="header-column-cell cor-movimento-mes mr-0">5</p><p className="header-column-cell cor-movimento-mes-seguinte ml-0">3</p></div>
            // <div className="d-flex w-100"><p className="header-column-cell cor-movimento-mes mr-0">5</p><p className="header-column-cell cor-movimento-mes-seguinte ml-0">3</p></div>
          
        )}
      </div>
 
      <div className="d-flex border-top border-left border-right border-bottom">
        {anos.map(ano=>
          <div className="px-0  w-100"><p className="column-cell">{ano.ano}</p></div>
        )}
        {/* <div className="px-0  w-100"><p className="column-cell">2022</p></div> */}
        {/* <div className="px-0  w-100"><p className="column-cell">2023</p></div> */}
      </div>
    </div>
    </>
  )
}

export default Movimentação;